import {Injectable, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';

import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/toPromise';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import {Observer} from 'rxjs/Rx';
import myGlobals = require('../config');

declare var $: any;
import * as _ from "lodash";
var jwtDecode = require('jwt-decode');



@Injectable()
export class LoginService {
    private loggedIn: Boolean;
    logIn: EventEmitter<boolean>;
    private usuario : any;

    // store the URL so we can redirect after logging in
    public redirectUrl: string;
    error: Observable<any>;
    private errorObserver: Observer<any>;


    constructor(private router: Router,
                public http: Http) {
        this.loggedIn = !!localStorage.getItem('jwtSGDI');
        this.logIn = new EventEmitter<boolean>();
        this.redirectUrl = "";
        this.error = Observable.create((observer: Observer<any>) => {
            this.errorObserver = observer;
        }).share();
    }

    login(usuario, password) {
        //this.logout();
        let headers = new Headers({'Content-Type': 'application/json'});
        this.http
            .post(myGlobals.default.BASE_URL + '/authenticate', JSON.stringify({usuario, password}), {headers: headers})
            .toPromise()
            .then(res => {
                if (res.json().token != undefined) {
                    localStorage.setItem('jwtSGDI', res.json().token);

                    var base64Url = res.json().token.split('.')[1];
                    var base64 = base64Url.replace('-', '+').replace('_', '/');
                    this.usuario = JSON.parse(window.atob(base64));

                    //si tengo url guardada redirijo ahi
                    let redirect = this.redirectUrl ? this.redirectUrl : '/home';
                    // Redirect the user
                    this.router.navigate([redirect]);
                    this.loggedIn = true;
                    this.logIn.emit(true);
                }
            })
            .catch((error) => {
                this.errorObserver.next(JSON.parse(error._body).message)
            });
    }

    logout() {
        localStorage.removeItem('jwtSGDI');
        this.loggedIn = false;
        this.logIn.emit(false);
        let link = ['/login'];
        this.router.navigate(link);
        setTimeout(()=>location.reload(),1000);
    }

    forgotPassword(usuario) {
        let headers = new Headers({'Content-Type': 'application/json'});
        this.http
            .post(myGlobals.default.BASE_URL + '/forgot', JSON.stringify({usuario}), {headers: headers})
            .toPromise()
            .then(res => {
                this.errorObserver.next(res);
            })
            .catch((error) => {
                this.errorObserver.next(JSON.parse(error._body).message);
            });
    }

    validateReset(token){
        let headers = new Headers({'Content-Type': 'application/json'});
        this.http
            .get(myGlobals.default.BASE_URL + '/reset/'+token,  {headers: headers})
            .toPromise()
            .then(res => {
                //this.errorObserver.next(JSON.parse(res._body).message);
            })
            .catch((error) => {
                this.errorObserver.next(JSON.parse(error._body).message);
            });
    }

    resetPassword(token,password){
        let headers = new Headers({'Content-Type': 'application/json'});
        this.http
            .post(myGlobals.default.BASE_URL + '/reset/'+token, JSON.stringify({password}), {headers: headers})
            .toPromise()
            .then(res => {
                let redirect = '/login';
                this.router.navigate([redirect]);
               // this.errorObserver.next(JSON.parse(res._body).message);
            })
            .catch((error) => {
                this.errorObserver.next(JSON.parse(error._body).message);
            });
    }

    isLoggedIn() {
        return !!localStorage.getItem('jwtSGDI');
    }

    getToken() {
        return localStorage.getItem('jwtSGDI');
    }

    getDecodeToken() {

        let token = this.getToken();
        if (token != null) {
            var datos = jwtDecode(token);
            this.usuario = datos;
        }
        else
            this.usuario = {};
        return this.usuario;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/login/login.service.ts